import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/download-history")
export class AdminViewDownloadHistoryBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.downloadHistory;
}
